import React, { useState } from "react";
import { Button, Col, Row, Stack } from "react-bootstrap";
import { postJob } from "../../../services/httpClient";
import Input from "../../ui/Input";
import { unsavedChanges } from "../../../App";
import DepartmentCard from "./DepartmentCard";

interface JobsState {
  jobs: any;
  getJobs: any;
  setOrgToSave: any;
  setErrMessage: any;
  setShowToast: any;
  setToastText: any;
  setToastBody: any;
}

const Jobs = ({ jobs, getJobs, setOrgToSave, setErrMessage, setShowToast, setToastText, setToastBody }: JobsState) => {
  const [showAddJobDept, setShowAddJobDept] = useState<boolean>(false);
  const [newDept, setNewDept] = useState<string>("");
  const [newJob, setNewJob] = useState<string>("");
  const [newPositionTotal, setNewPositionTotal] = useState<number>();

  const onClickAddJob = () => {
    setShowAddJobDept(true);
    setNewDept("");
    setNewJob("");
    setNewPositionTotal(undefined);
  };

  const updateNewDept = (e: any) => {
    setNewDept(e.target.value);
    unsavedChanges.value = true;
    setOrgToSave(true);
  };

  const updateNewJob = (e: any) => {
    setNewJob(e.target.value);
    unsavedChanges.value = true;
    setOrgToSave(true);
  };

  const updateNewPositionTotal = (e: any) => {
    setNewPositionTotal(e.target.value);
    unsavedChanges.value = true;
    setOrgToSave(true);
  };

  const onClickSaveJob = (isDone: boolean = false, deptId: string) => {
    const _job = {
      name: newJob,
      positions_total: newPositionTotal,
    };

    setErrMessage("");

    postJob(_job, deptId)
      .then((res: any) => {
        setShowToast(true);
        setToastText("Job Created");
        setToastBody(newJob);
        setNewJob("");
        setNewPositionTotal(undefined);
        unsavedChanges.value = false;
        setOrgToSave(false);
        if (isDone) {
          setNewDept("");
          setShowAddJobDept(false);
        }
        getJobs(true);
      })
      .catch((err: any) => {
        setErrMessage(err?.response?.data?.msg);
        window.scrollTo({
          top: 0,
          behavior: "auto",
        });
      });
  };

  const onClickCancelAddJob = () => {
    setErrMessage("");
    setShowAddJobDept(false);
    setNewDept("");
    setNewJob("");
    setNewPositionTotal(undefined);
    unsavedChanges.value = false;
    setOrgToSave(false);
  };

  return (
    <>
      {jobs.length === 0 ? (
        <p className="mt-2">No Job Records</p>
      ) : (
        <Row>
          <Col xs={12}>
            <Stack gap={3}>
              {jobs?.map((dept: any, index: number) => (
                <DepartmentCard
                  key={index}
                  department={dept}
                  getJobs={getJobs}
                  setOrgToSave={setOrgToSave}
                  setErrMessage={setErrMessage}
                  setShowToast={setShowToast}
                  setToastText={setToastText}
                  setToastBody={setToastBody}
                />
              ))}
            </Stack>
          </Col>
        </Row>
      )}
      {showAddJobDept !== true && (
        <Row className="mt-3">
          <Col xs={6} lg={4}>
            <Button className="app-tertiary-color button" onClick={(e) => onClickAddJob()}>
              Add Job
            </Button>
          </Col>
        </Row>
      )}
      {showAddJobDept === true && (
        <>
          <Row className="align-items-center my-3">
            <Col xs={3}>
              <Input label="Department" type="text" value={newDept} onUpdate={(e: any) => updateNewDept(e)} hasFocus={true} />
            </Col>
            <Col xs={6}>
              <Input label="Job" type="text" value={newJob} onUpdate={(e: any) => updateNewJob(e)} required={true} />
            </Col>
            <Col xs={3}>
              <Input
                label="Positions #"
                type="number"
                value={newPositionTotal}
                onUpdate={(e: any) => updateNewPositionTotal(e)}
                required={true}
              />
            </Col>
          </Row>
          <Row>
            <Col xs={12} lg={8}>
              <Stack direction="horizontal" gap={3}>
                <Button className="app-secondary-color button" onClick={() => onClickSaveJob(false, "1")}>
                  Save and Add Another
                </Button>
                <div className="vr" />
                <Button className="app-secondary-color button" onClick={() => onClickSaveJob(true, "1")}>
                  Save and Done
                </Button>
                <div className="vr" />
                <Button className="app-primary-color button" onClick={() => onClickCancelAddJob()}>
                  Done
                </Button>
              </Stack>
            </Col>
          </Row>
        </>
      )}
      <Row className="mb-5"></Row>
    </>
  );
};

export default Jobs;
